<template>
  <div
    id="cartao_verso"
    style="
      position: relative;
      width: 50%;
      height: auto;
      float: left;
      z-index: 1;
    "
  >
    <div class="cartao_layout cartao_verso">
      <div
        class="rodateto"
        style="font-size: 8.5px"
        v-if="
          informacoesVerso.valido_somente_com_apresentacao_documento_identidade
        "
      >
        Válido somente com apresentação do documento de Identidade
      </div>
      <div class="tarja_magnetica"></div>

      <div class="inf_plano" style="font-size: 8.5px">
        Eventuais alterações ocorridas na rede de prestadores poderão ser
        consultadas no
        <span style="text-decoration: underline">{{
          cartaoVerso.siteUnimed
        }}</span>
      </div>

      <div
        v-if="cartaoVerso.coberturaUrgenciaEmergencia !== null"
        class="inf_plano"
        style="font-size: 9px; font-weight: 600; line-height: 9px;"
      >
        {{ cartaoVerso.coberturaUrgenciaEmergencia }}
      </div>
      <br />
      <v-menu
        v-model="menuCarencias"
        offset-x
        right
        :close-on-content-click="false"
        content-class="card-tooltip"
      >
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
            style="font-size:9px; cursor:pointer; font-weight:600; padding-left:15px;"
          >
            CARÊNCIAS <v-icon small color="orange">info</v-icon>
          </span>
        </template>

        <v-card style="width: 350px; border-radius: unset;">
          <v-card-text style="font-size: 9px;">
            <table
              class="inf_plano lista_carencias"
              style="font-size:9px; width: 95%;"
            >
              <tbody>
                <tr
                  v-for="(carencia, index) in cartaoVerso.carencias"
                  :key="index"
                >
                  <td class="columns-9">{{ carencia.procedimento }}</td>
                  <td class="columns-2">{{ carencia.carencia }}</td>
                </tr>

                <tr
                  v-if="!cartaoVerso.carencias || !cartaoVerso.carencias.length"
                >
                  <td colspan="2" style="text-align:center; padding: 20px 0;">
                    SEM CARÊNCIAS A CUMPRIR
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </v-menu>
      <br />
      <v-menu
        v-model="menuMensagens"
        offset-x
        right
        :close-on-content-click="false"
        content-class="card-tooltip"
      >
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
            style="
        font-size: 9px;
        padding-left: 15px;
        cursor: pointer;
        font-weight: bold;
      "
          >
            MENSAGENS ADICIONAIS
            <v-icon small color="orange">info</v-icon>
          </span>
        </template>

        <v-card style="width: 380px; border-radius: unset;">
          <v-card-text style="font-size: 9px;">
            <table
              class="inf_plano lista_carencias"
              style="font-size:9px; width: 100%;"
            >
              <tbody>
                <tr
                  v-for="(mensagemAdicional,
                  index) in cartaoVerso.mensagensAdicionais"
                  :key="index"
                >
                  <td>{{ mensagemAdicional }}</td>
                </tr>
                <tr
                  v-if="
                    !cartaoVerso.mensagensAdicionais ||
                      !cartaoVerso.mensagensAdicionais.length
                  "
                >
                  <td colspan="2">
                    SEM MENSAGENS ADICIONAIS
                  </td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </v-menu>
      <br />
      <table
        class="inf_plano lista_msg_repasses"
        style="
          font-size: 9px;
          padding-top: 0px;
          border-collapse: unset;
          border-spacing: unset;
        "
      >
        <tbody>
          <tr
            v-for="(msgRepasse, index) in cartaoVerso.mensagemUnimedRepasse"
            :key="index"
          >
            <td class="columns-9">{{ msgRepasse }}</td>
          </tr>
          <tr
            v-if="
              !cartaoVerso.mensagemUnimedRepasse ||
                !cartaoVerso.mensagemUnimedRepasse.length
            "
          >
            <td
              colspan="2"
              style="
                text-align: center;
                font-size: 9px;
                padding: 0px;
              "
            >
              SEM MENSAGENS DE REPASSE
            </td>
          </tr>
        </tbody>
      </table>

      <div style="clear: both"></div>
      <ul class="rodape">
        <li style="width: 90px; height: 32px; padding: 25px 0 0 0">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            style="position: absolute; bottom: 0px; right: 0px; font-size: 7px"
          >
            <tbody>
              <tr>
                <td style="text-align: right">
                  Cód. Prod. ANS:
                  {{ cartaoVerso.codigoProdutoAns }}
                </td>
              </tr>
              <tr>
                <td style="text-align: right">
                  CNS:
                  {{ cartaoVerso.codigoCns }}
                </td>
              </tr>
              <tr v-if="informacoesVerso.telefone_ouvidoria">
                <td style="text-align: right">
                  Ouvidoria:
                  {{ cartaoVerso.telefoneOuvidoria }}
                </td>
              </tr>
            </tbody>
          </table>
        </li>
        <li style="width: 180px; text-align: center; font-size: 8.5px">
          <div v-if="informacoesVerso.sac_telefone">
            <span style="font-weight: 700">SAC/Informações:</span><br />
            <span style="font-size: 9px; font-weight: 700">{{
              cartaoVerso.numeroSac
            }}</span>
          </div>
          <div style="text-transform: uppercase">
            <div class="columns-5 ans">
              <div
                style="
                  width: calc(100% - 1px);
                  height: 13px;
                  border: 1px solid #fff;
                "
              >
                ANS - nº {{ cartaoVerso.codigoRegistroAns }}
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div id="caixaMarcaDagua" v-if="cartaoInativo">
        <span id="span_texto">BENEFICIÁRIO INATIVO</span>
      </div>
      <div
        v-if="informacoesVerso.informacoes_ans"
        class="inf_add rotate90"
        style="top: 130px; left: -120px; height: 10px; padding: 0px 2px 2px 67px;"
      >
        Disque-ANS 0800 701 9656 www.ans.gov.br
      </div>

      <div
        v-if="informacoesVerso.este_cartao_numerado_nominativo_intransfervel"
        class="inf_add2 rotate-90"
        style="top: 125px; right: -120px; text-transform: uppercase"
      >
        Este cartão é numerado, nominativo e intransferível
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import { WEB_SERVICE } from "@/constants";

import { buscaDadosCartaoVerso } from "@/services/beneficiario";

const { mapMutations } = createNamespacedHelpers("portal");
const { mapGetters } = createNamespacedHelpers("beneficiario");

export default {
  name: "CartaoVerso",
  props: {
    beneficiarioCartao: String,
    informacoesVerso: Object
  },
  data() {
    return {
      cartaoVerso: {},
      cartaoInativo: null,
      menuMensagens: null,
      menuCarencias: null
    };
  },
  computed: {
    ...mapGetters(["getDadosBeneficiario"])
  },
  watch: {
    beneficiarioCartao: {
      handler() {
        this.buscaDadosCartaoVerso();
      }
    }
  },
  mounted() {
    this.buscaDadosCartaoVerso();
    this.checkBnfrioAtivo();
  },
  methods: {
    ...mapMutations(["setErrorToast", "setToast"]),
    checkBnfrioAtivo() {
      this.cartaoInativo = !this.getDadosBeneficiario.ativo;
    },
    async buscaDadosCartaoVerso() {
      this.$emit("cartao-verso", true);

      await buscaDadosCartaoVerso(this.beneficiarioCartao)
        .then(response => {
          this.checkBnfrioAtivo();
          let carencias = [];
          let mensagemUnimedRepasse = [];
          let mensagensAdicionais = [];

          if (response.carenciasDescricao) {
            const carenciaDatas = response.carenciasData
              ? response.carenciasData.split(";")
              : [];

            carencias = response.carenciasDescricao
              .split(";")
              .map((procedimento, index) => ({
                procedimento,
                carencia: carenciaDatas[index]
              }));
          }

          if (response.mensagemUnimedRepasse) {
            mensagemUnimedRepasse = response.mensagemUnimedRepasse
              ? response.mensagemUnimedRepasse.split(";")
              : [];
          }

          if (response?.mensagensAdicionais) {
            mensagensAdicionais = response?.mensagensAdicionais
              ? response.mensagensAdicionais
                  .split(";")
                  .filter(item => item.trim() !== "")
              : [];
          }

          this.cartaoVerso = {
            ...response,
            carencias,
            mensagemUnimedRepasse,
            mensagensAdicionais
          };
        })
        .catch(({ response }) => {
          const resultado = response?.data?.message?.split("|");

          if (WEB_SERVICE.includes(resultado[0])) {
            this.setErrorToast(response?.data?.message);
          } else {
            this.setToast(
              response.data ? response.data.message : response.message
            );
          }
        })
        .finally(() => {
          this.$emit("cartao-verso", false);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/cartao-beneficiario.scss";
#caixaMarcaDagua {
  width: 100%;
  position: absolute;
  top: 262px;
  left: 0;
  height: 42px;
  z-index: -1;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background: #c3c3c3;
  box-shadow: 3px 4px 4px 0px rgb(0 0 0 / 12%), 0px 2px 4px 0px rgb(0 0 0 / 64%);
}
#span_texto {
  top: 12px;
  position: absolute;
  color: black;
  text-align: center;
  font-weight: bold;
  height: 22px;
  left: 114px;
  padding-top: 3px;
  border-radius: 5px;
  opacity: 0.7;
  width: 152px;
  font-size: 14px;
}

.card-tooltip {
  margin-top: 10px;
}

.v-card {
  border-radius: 12px;
  position: relative;
}

.v-card::after {
  content: "";
  position: absolute;
  top: -6px;
  left: -5px;
  width: 13px;
  height: 15px;
  background: black;
  transform: rotate(45deg);
}
</style>
